<template>
    <div class="payment section">
        <h3>Payment information</h3>

        <payment-credit
            :stripe-key="stripeKey"
            :selected="method === 'credit'"
            :hide-radio="!maySendCheck"
            @selected="method = 'credit'"
            @valid="creditValid = $event"
            ref="credit"
            :last4="last4"
        />

        <payment-check
            v-if="maySendCheck"
            :selected="method === 'check'"
            @selected="method = 'check'"
            @valid="checkValid = $event"
        />
    </div>
</template>

<script>
import PaymentCredit from './ReservationRequest-Payment-Credit';
import PaymentCheck from './ReservationRequest-Payment-Check';

export default {
    components: {
        PaymentCredit,
        PaymentCheck,
    },

    props: {
        stripeKey: {
            type: String,
        },
        last4: {
            type: String,
        },
        maySendCheck: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            method: 'credit',
            creditValid: false,
            checkValid: false,
        };
    },

    watch: {
        method() {
            this.emitStatus();
        },
        creditValid() {
            this.emitStatus();
        },
        checkValid() {
            this.emitStatus();
        },
    },

    methods: {
        emitStatus() {
            let valid = false;
            valid ||= this.method === 'credit' && this.creditValid;
            valid ||= this.method === 'check' && this.checkValid;

            this.$emit('valid', valid);
        },
    },
}
</script>

<style lang="scss">
.payment {
    margin-bottom: 20px;

    h4 {
        text-decoration: none;
        font-size: 14pt;
        margin-left: 45px;
    }

    fieldset {
        border: 1px solid #bbb;
        display: inline-block;
        width: 100%;
        max-width: 35em;
        padding: 10px 20px;
        margin: 10px 0 20px 70px;

        @media (max-width: 600px) {
            margin-left: 0;
            padding: 5px;
        }
    }
}
</style>
